import request from "@/utils/request";

export async function getDashboard() {
    console.log("@@ get : getDashboard");
    let result = request.get("/api/dashboard/",{});
    return result;
}
